<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  watch: {
    $route: function(to, from) {
      if (to.name.indexOf("_m") < 0 && !this.$pc) {
         this.$router.replace(to.path);
        // this.$router.replace(to.name + "_m");
        // this.$router.replace(to.name.split('_m')[0])
        //电脑转手机端
        //域名为index_p去掉_p变成手机端index路由
        // if (to.name == "index_p") {
        //   let str = to.name.split("_p")[0];
        //   let str2 = '/' + str;
        //   this.$router.push(str2);
        // }
      } else if (to.name.indexOf("_m") > 0 && this.$pc) {
        //手机端转电脑
        //在路由尾巴添加_p变成电脑端
        this.$router.replace(to.name.split("_m")[0]);
      }
    }
  },

  mounted() {},
  methods: {}
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
}

body {
  /* font: 12px Arial, "PingFang SC", "Hiragino Sans GB", STHeiti,
      "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif; */
  font-family: "Microsoft YaHei,Microsoft YaHei-Regular";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  /* background: #000; */
}

[v-cloak] {
  display: none;
}

img[src=""] img:not([src]) {
  opacity: 0;
}

#app {
  width: 100%;
  height: 100%;
}

#nprogress .bar {
  background: #d0a48d !important;
}

a {
  text-decoration: none;
}

body::-webkit-scrollbar {
  width: 6px;
  flex: 1;
}

body::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px #d8d8d8;
  background: #535353;
}

body::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px #d8d8d8;
  border-radius: 10px;
  background: #ededed;
}

.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  vertical-align: inherit !important;
}

.rotate-circle,
.tmap-zoom-control,
.logo-text {
  display: none;
}

.mapcontent div {
  line-height: 28px;
  text-align: left;
  font-size: 16px;
}

.mapcontent1 div {
  line-height: 28px;
  text-align: left;
  font-size: 12px;
}

.mapcontent {
  background: #0967f9;
  color: #fff;
  padding: 20px;
  border-radius: 4px;
  position: relative;
}

.mapcontent1 {
  background: #0967f9;
  color: #fff;
  padding: 10px;
  border-radius: 4px;
  position: relative;
}

.trangle {
  width: 0px;
  height: 0px;
  border: 10px solid #000;
  border-top-color: #0967f9;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  margin: auto;
}

.el-upload-dragger {
  background: none !important;
  border: none !important;
  height: auto !important;
  border-radius: none !important;
  width: auto !important;
}
.tmap-scale-control {
  display: none;
}

/*带背景的分页按钮背景色begin*/
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #00A9BA;
  color: #FFF;
}
.el-pagination.is-background .el-pager li.active {
  background-color: #00A9BA !important;
  color: #fff;
  cursor: default;
}

.el-carousel__arrow:hover{
  background: #00A9BA !important;
}

 .el-carousel__arrow i{
  color: #fff !important;
}
 /* 指示器按钮 */
 .el-carousel__button {
    background: #D7DBE0 !important;
    height: 4px !important;
}
 /* 指示器激活按钮 */
 .is-active .el-carousel__button {
    background: #00A9BA !important;
    height: 4px !important;
}
.el-carousel__indicator--horizontal{
  padding: 12px !important;
}
/* 菜单悬停hover效果 */
.el-submenu__title:focus, .el-submenu__title:hover{

  color: #00A9BA !important;
}
.el-menu-item:hover{
  color: #00A9BA !important;
}
.el-menu-item.is-active {
  color: #00A9BA !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue